<template>
  <!-- Copied: the button itself says so for a moment, then turns back. -->
  <button class="slideshow-copy" type="button" :class="{ 'is-copied': copied }">
    <span class="slideshow-copy__face" :aria-hidden="copied">
      <SlideshowIcon name="link" />
      {{ texts.copyLink }}
    </span>
    <span class="slideshow-copy__face is-done" :aria-hidden="!copied">
      <SlideshowIcon name="check" />
      {{ texts.copiedShort }}
    </span>
    <span aria-live="polite" class="screen-reader-text">
      {{ copied ? texts.copied : "" }}
    </span>
  </button>
</template>

<script lang="ts" setup>
  import { slideshowTexts } from "../../composables/useSlideshow";
  import SlideshowIcon from "./SlideshowIcon.vue";

  defineProps<{ copied: boolean }>();

  const texts = slideshowTexts();
</script>
